// Resize + re-encode a photo in the browser so only a compact JPEG is sent for reading.
export function compressImage(file, maxSide = 2400, quality = 0.88) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxSide / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error(`Cannot open ${file.name}. Use a JPG or PNG photo.`)); };
    img.src = url;
  });
}

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });

// Cut the handwritten line out of the page (box = [ymin,xmin,ymax,xmax] 0-1000) and turn it upright.
export async function cropLines(dataUrl, entries, rotation) {
  const img = await loadImg(dataUrl);
  const W = img.width, H = img.height;
  return entries.map((e) => {
    const b = e.box_2d;
    if (!Array.isArray(b) || b.length !== 4) return e;
    const [y0, x0, y1, x1] = b;
    const pad = 35;
    const sx = Math.max(0, ((x0 - pad) / 1000) * W), sy = Math.max(0, ((y0 - pad) / 1000) * H);
    const sw = Math.min(W - sx, ((x1 - x0 + 2 * pad) / 1000) * W), sh = Math.min(H - sy, ((y1 - y0 + 2 * pad) / 1000) * H);
    if (sw < 4 || sh < 4) return e;
    const rot = [90, 180, 270].includes(rotation) ? rotation : 0;
    const swap = rot === 90 || rot === 270;
    const scale = Math.min(1, 520 / (swap ? sh : sw));
    const c = document.createElement("canvas");
    c.width = Math.round((swap ? sh : sw) * scale);
    c.height = Math.round((swap ? sw : sh) * scale);
    const ctx = c.getContext("2d");
    ctx.translate(c.width / 2, c.height / 2);
    ctx.rotate((rot * Math.PI) / 180);
    ctx.drawImage(img, sx, sy, sw, sh, (-sw * scale) / 2, (-sh * scale) / 2, sw * scale, sh * scale);
    return { ...e, crop: c.toDataURL("image/jpeg", 0.7) };
  });
}

// "3+4.5" -> 7.5 ; anything else -> null
export function sumExpr(text) {
  const t = (text || "").replace(/\s/g, "");
  if (!/^\d+(\.\d+)?(\+\d+(\.\d+)?)*$/.test(t)) return null;
  return Math.round(t.split("+").reduce((a, p) => a + Number(p), 0) * 1000) / 1000;
}

export const STATUS = {
  matched: { label: "Matched", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  mismatch: { label: "Quantity Mismatch", cls: "bg-red-100 text-red-800 border-red-200" },
  missing_on_website: { label: "Missing on Website", cls: "bg-orange-100 text-orange-800 border-orange-200" },
  missing_in_book: { label: "Missing in Book", cls: "bg-purple-100 text-purple-800 border-purple-200" },
  needs_check: { label: "Needs Manual Check", cls: "bg-amber-100 text-amber-800 border-amber-200" },
};

export const newEntry = (plant, extra = {}) => ({
  id: (crypto.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random()),
  plant, page: null, date: "", customer_read: "", tons_text: "", tons: null,
  uncertain: false, overwritten: false, alternatives: [], confirmed: true,
  matched_customer: null, new_customer: false, note: "Added manually", ...extra,
});
